import { axios } from '@/utils/request'
import qs from 'qs'
let moduleName="updateInfo";

export function selectAll(){
  return axios({
    url: `/ws/${moduleName}`,
    method: 'get',
  })
}

export function selectAllPicker(){
  return axios({
    url: `/ws/${moduleName}/selectAllPicker`,
    method: 'get',
  })
}

export function selectOne(parameter){
  console.log("id:",parameter)
  return axios({
    url: `/ws/${moduleName}/${parameter}`,
    method: 'get'
  })
}


export function getNewUpdateInfo(){
  console.log("id:")
  return axios({
    url: `/ws/${moduleName}/getNewUpdateInfo`,
    method: 'get'
  })
}

export function getByDate(date){
  console.log("id:",date)
  return axios({
    url: `/ws/${moduleName}/getByDate/${date}`,
    method: 'get'
  })
}


export function insert(parameter){
  console.log("data:",parameter)
  return axios({
    url: `/ws/${moduleName}`,
    method: 'post',
    data:parameter
  })
}

export function update(parameter){
  console.log("data:",parameter)
  return axios({
    url: `/ws/${moduleName}`,
    method: 'put',
    data:parameter
  })
}


export function deleteObj(ids){
  console.log("ids",ids)
  return axios({
    url: `/ws/${moduleName}`,
    method: 'delete',
    params:ids,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
}
export default {
  selectAll,
  getByDate,
  selectAllPicker,
  selectOne,
  update,
  save:insert,
  getNewUpdateInfo,
  delete:deleteObj
}